module.exports = __webpack_public_path__ + "static/media/23.cb4106bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/23.png
// module id = 876
// module chunks = 0